import { jsx as _jsx } from "react/jsx-runtime";
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { IconButton, Tooltip } from '@mui/material';
import { useCallback, useContext } from 'react';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
export const NavigationDrawerButton = ({ isAuthenticated, onDrawerToggle, onFullscreenToggle }) => {
    const [{ fullscreen, isSmallView, navDrawerOpen }] = useContext(AppMainViewContext);
    const menuButtonClick = useCallback(() => {
        if (!isAuthenticated)
            return;
        if (isSmallView || fullscreen)
            return onDrawerToggle();
        else
            return onFullscreenToggle();
    }, [isAuthenticated, isSmallView, fullscreen, navDrawerOpen]);
    return (_jsx(Tooltip, { title: fullscreen ? 'Toggle drawer' : 'Collapse drawer', placement: "bottom", arrow: true, children: _jsx(IconButton, { color: "inherit", "aria-label": "open drawer", onClick: menuButtonClick, sx: {
                overflow: 'hidden',
                maxWidth: !isAuthenticated ? 0 : 40,
                paddingInline: !isAuthenticated ? 0 : 1,
                transitionProperty: 'max-width, padding-inline',
                transitionTimingFunction: 'ease-in-out',
                transitionDuration: '.15s',
                ['&:hover']: { backgroundColor: (t) => t.palette.primary.dark },
            }, children: isSmallView || fullscreen ? _jsx(MenuIcon, {}) : _jsx(MenuOpenIcon, {}) }) }));
};
